import {
  isInternalReviewer,
  isOeReviewer,
  isQuestDesigner,
  isQuestCopyEditor,
  isQuestDesignerOrIsQuestManager,
  isQuestManager
} from './user'

const isOnQueueRoute = currentPath =>
  currentPath.indexOf('queue') > -1 &&
  currentPath.indexOf('reviewqueue') &&
  currentPath.indexOf('reviewqueue') < 0

const isOnAllQuestsRoute = currentPath =>
  currentPath.indexOf('quests') > -1 && currentPath.indexOf('/myquests') < 0

const isOnNavRoute = (currentPath, navRoute) =>
  currentPath.indexOf(navRoute) > -1

const userCanSeeQueue = user =>
  (isInternalReviewer(user) ||
    isQuestCopyEditor(user) ||
    isQuestManager(user)) &&
  !isQuestDesigner(user)

const userCanSeeMyQuests = user => isQuestDesignerOrIsQuestManager(user)

const userCanSeeReviewQueue = user => isOeReviewer(user)

const userCanSeeProductionStatus = (user, courses) =>
  courses.length > 0 &&
  courses.some(c => c.mock_levels.length > 0) &&
  (isOeReviewer(user) || isQuestManager(user))

export {
  isOnAllQuestsRoute,
  isOnQueueRoute,
  isOnNavRoute,
  userCanSeeQueue,
  userCanSeeMyQuests,
  userCanSeeReviewQueue,
  userCanSeeProductionStatus
}



// WEBPACK FOOTER //
// ./src/utils/navigation.js